import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { APIEventsEnum, useSendEvent } from '../hooks';
import { downloadFile } from '@/core/helpers';

import Button from './Button';
import SellerInstructionsWrapper from './SellerInstructionsWrapper';

import BookIcon from '@/icons/book.svg?react';
import DownloadIcon from '@/icons/download.svg?react';
import LinkIcon from '@/icons/link.svg?react';

export default function SellerGuidelines() {
  const { sendEvent } = useSendEvent();
  const { t, i18n } = useTranslation();

  return (
    <>
      <SellerInstructionsWrapper
        heading={t('Guidelines')}
        icon={<BookIcon className='h-10 w-10' />}
        className='!py-4'
      />
      <SellerInstructionsWrapper
        heading={t('How to prepare your Manual Turnover Data')}
        className='gap-y-4 px-6'
      >
        <div>
          <Link
            className={`Button--outline mb-2 inline-flex !w-full items-center !px-2 !py-1 ${
              i18n.language === 'de' ? 'max-w-[214px]' : 'max-w-[192px]'
            }`}
            to={
              i18n.language === 'de'
                ? '/Manual_data_preparation_DE.pdf'
                : '/Manual_data_preparation_ENG.pdf'
            }
            target='_blank'
            rel='noopener noreferrer'
            onClick={() => {
              sendEvent(APIEventsEnum.download_manual_upload_instruction, {
                block: 'Download Manual Upload Instruction',
              });
            }}
          >
            <LinkIcon className='mr-2 h-6 w-6' />
            <span>{t('Open instruction')}</span>
          </Link>
          <Button
            styling='outline'
            className={`flex !w-full items-center !px-2 !py-1 ${
              i18n.language === 'de' ? 'max-w-[214px]' : 'max-w-[192px]'
            }`}
            onClick={() => {
              sendEvent(APIEventsEnum.download_manual_upload_template, {
                block: 'Download Manual Upload Template',
              });
              downloadFile(
                i18n.language === 'en'
                  ? '/countX-Turnover-Import-Template_Example.xlsx'
                  : '/countX-Turnover-Import-Vorlage_Beispiel.xlsx',
                i18n.language === 'en'
                  ? 'countX-Turnover-Import-Template_Example.xlsx'
                  : 'countX-Turnover-Import-Vorlage_Beispiel.xlsx'
              );
            }}
          >
            <DownloadIcon className='mr-1 [&>path]:fill-dark' />
            <span>{t('Download template')}</span>
          </Button>
        </div>
      </SellerInstructionsWrapper>
      <SellerInstructionsWrapper
        heading={t('How to work with documents interface')}
        className={`gap-y-4 ${i18n.language === 'de' ? 'px-8' : ''}`}
      >
        <Link
          className={`Button--outline inline-flex !w-full items-center !px-2 !py-1 ${
            i18n.language === 'de' ? 'max-w-[214px]' : 'max-w-[192px]'
          }`}
          to='/data-files/how-to-work'
          target='_blank'
          rel='noopener noreferrer'
          data-testid='documents-instruction-link'
        >
          <LinkIcon className='mr-2 h-6 w-6' />
          <span>{t('Open instruction')}</span>
        </Link>
      </SellerInstructionsWrapper>
    </>
  );
}
